(ns kyber.components.composite.tooltip
  (:require [re-frame.core :as re-frame]
            [reagent.core :as reagent]

            [kyber.components.base.text :as text]
            [kyber.styles.core :refer [gs styles->classes]]))

(def tooltip-z-index 100)
(def tooltip-width 200)
(def tooltip-delay 100)
(def padding 12)

(def classes
  (styles->classes
   {:tooltip-container
    {:display :none ;; TODO Remove when re-enabled

     :pointer-events :none
     :position :absolute
     :border-radius (gs [:radius :r3])
     :z-index tooltip-z-index
     :padding [[(gs [:spacing :p4])
                (gs [:spacing :p12])]]
     :margin (gs [:spacing :p0])
     :width "auto"
     :box-shadow (gs [:shadows :shadow-12])
     :background-color (gs [:colors :gray-scale-600])}

    :tooltip-copy
    {:color (gs [:colors :true-white])}}))

(defn add-tooltip
  [component _tip]
  ;; TODO: Disabling tooltips until we have more time to revisit
  ;;       implementation.
  ;; NOTE: I would like to move this out of re-frame and into the
  ;;       the individual components.
  [:div #_{:on-mouse-enter #(re-frame/dispatch
                           [:ui/show-tooltip
                            (merge tip
                                   {:x (.-pageX %)
                                    :y (.-pageY %)})])
         :on-mouse-leave #(re-frame/dispatch [:ui/hide-tooltip])}
   component])

(defn- update-tooltip-styles
  [!ref tooltip-styles {:keys [x y]} previous-coords]
  (js/setTimeout
   #(let [width (.max js/Math
                      (-> js/document .-documentElement .-clientWidth)
                      (or (.-innerWidth js/window) 0))
          height (.max js/Math
                       (-> js/document .-documentElement .-clientHeight)
                       (or (.-innerHeight js/window) 0))
          tooltip-height (.-clientHeight @!ref)
          tooltip-width (.-clientWidth @!ref)]

      (reset! tooltip-styles {:top (if (> (/ height 2) y)
                                     (+ y padding)
                                     (- y padding tooltip-height))
                              :left (if (> (/ width 2) x)
                                      (+ x padding)
                                      (- x padding tooltip-width))})
      (reset! previous-coords {:x x :y y :max-width
                               (.min js/Math (- width 20) 350)}))
   tooltip-delay))

(defn render
  []
  (let [tooltip (re-frame/subscribe [:ui/tooltip])
        !ref (atom nil)
        tooltip-styles (reagent/atom {})
        previous-coords (atom {:x nil :y nil})]
    (fn []
      (let [{:keys [x y]} @tooltip
            {prev-x :x prev-y :y} @previous-coords]

        (when (or (not= x prev-x)
                  (not= y prev-y))
          (update-tooltip-styles
           !ref tooltip-styles @tooltip previous-coords))

        [:div {:on-mouse-enter #(re-frame/dispatch [:ui/hide-tooltip])
               :class (:tooltip-container classes)
               :style (assoc @tooltip-styles
                             :visibility (if (and (some? @tooltip)
                                                  (pos? prev-y))
                                           :visible :hidden))
               :ref #(reset! !ref %)}
         [text/body-20 :p
          {:class (:tooltip-copy classes)}
          (:tip @tooltip)]]))))
